/* eslint-disable import/no-anonymous-default-export */
import { Form, Input, Progress, Table } from "antd";
import { FilterValue } from "antd/lib/table/interface";
import moment from "moment";
import { useContext, useEffect } from "react";
import DataFilter from "../common/components/DataFilter";
import DataTable from "../common/components/DataTable";
import EditableCell from "../common/components/EditableCell";
import MainLayout from "../common/components/MainLayout";
import useEquiposProcesamientoAPI, { EquipoProcesamiento } from "./useEquiposProcesamientoAPI";
import EquiposProcesamientoContext, {EquiposProcesamientoProvider} from "./EquiposProcesamientoContext";
import useEquiposProcesamientoHub, { EquipoProcesamientoConectado } from "./useEquiposProcesamientoHub";
import styled from "styled-components";


const StatusLed = styled.span<{status:('on'|'off')}>`
    display:block;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background-color:${(props)=>props.status == 'on' ? '#4caf50' : '#f44336'};
`;

const ProcessingInfo = styled.div`
margin-top: 1rem;
& > span
{
    font-size:0.8rem;
    & > span:first-child
    {
        font-weight:600;
    }
}
`;

const ServerMessages = styled.div`
max-height: 110px;
overflow: auto;
background-color: #e0e0e0;
padding: 0.5rem;
margin-top: 1rem;
display:grid;
gap:0.5rem;
& > div
{
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 1rem;
    align-items: center;
    span:nth-child(1) {font-weight: 600;}
}

`;

export default () => {
    const api = useEquiposProcesamientoAPI();
    const {
        disconnect,connect,devices,getConnectedDevices,
        sendStopAnalysis,sendStartAnalisys,sendGenerateExport,
        serverMessages
    } = useEquiposProcesamientoHub();
    const createPage = "/neuralvision/equipos-procesamiento/guardar"
    const editPage = "/neuralvision/equipos-procesamiento/guardar/{Id}"

    const [nombreFilterForm] = Form.useForm();
    const generateFilters = (filters: Record<string, FilterValue | null>) => {
        return [
            filters?.Nombre != null ? `contains(Nombre,'${filters!.Nombre![0]}')` : "",

        ];
    }
    
    const updateDevices =async () => {
        await getConnectedDevices();
    }

    const statusText = {
        0:'Conectado',
        1:'Generando buffer de video',
        2:'Análisis en progreso',
        3:'Iniciando proceso',
        4:'Error encontrado',
        5:'Verificando integridad',
        6:'Error en el disco',
        7:'Sin contenido para procesar',
        8:'Procesamiento finalizado',
        9:'Análisis detenido',
        10:'Deteniendo análisis',
        11:'Iniciando software'
    }

    const getConnectedDevice = (record:EquipoProcesamiento) => {
        if (!record) return undefined;
        const index = devices.findIndex(d => d.nombre == record.Nombre);
        if(index == -1) return undefined;
        return devices[index];
    };
    
    const getStatus=(record:EquipoProcesamiento)=>{
        const device = getConnectedDevice(record);
        if(!device) return undefined;
        return device.estado ?? {status:0,info:{}}
    }
    

    useEffect(() => {
        connect().then(updateDevices)
        return () => {
            disconnect();
        };

    }, []);

    return (
        <MainLayout>
            <DataTable<EquipoProcesamiento, EquipoProcesamiento>
                        list={(query)=>api.list({...query,...{$expand:[]}})}
                        delete={api.delete}
                        createAction={{
                            label: "Agregar equipo de procesamiento",
                            path: createPage
                        }}
                        deleteMultipleAction
                        defaultSortOrder={"Nombre desc"}
                        selectionType='checkbox'
                        title={"Equipos de procesamiento"}
                        generateFilters={generateFilters}
                        editItemAction={editPage}
                        deleteItemAction
                        deleteItemActionConfirmMessage={(item) => `¿Eliminar a ${item.Nombre}?`}
                        defaultPageSize={25}
                        itemActions={[{
                            key:'stop-analysis',
                            label:'Detener análisis',
                            /*checkDisabled(selectedItems, currentIndex, items) {
                                const connectedDevice = getConnectedDevice(selectedItems[currentIndex]);
                                if (!connectedDevice || ![2].includes(connectedDevice.estado?.status ?? 0)) return true;
                                return false;
                            },*/
                            action(item, selectedItems) {
                                const connectedDevice = getConnectedDevice(item);
                                if (!connectedDevice) return;
                                sendStopAnalysis(connectedDevice.idConexion);
                            },
                        },
                        {
                            key:'start-analysis',
                            label:'Iniciar análisis',
                            /*checkDisabled(selectedItems, currentIndex, items) {
                                const connectedDevice = getConnectedDevice(selectedItems[currentIndex]);
                                if (!connectedDevice || ![9,0,8,4,7].includes(connectedDevice.estado?.status ?? 0)) return true;
                                return false;
                            },*/
                            action(item, selectedItems) {
                                const connectedDevice = getConnectedDevice(item);
                                if (!connectedDevice) return;
                                sendStartAnalisys(connectedDevice.idConexion);
                            },
                        },
                        {
                            key:'generate-export',
                            label:'Generar exportación',
                            /*checkDisabled(selectedItems, currentIndex, items) {
                                const connectedDevice = getConnectedDevice(selectedItems[currentIndex]);
                                if (!connectedDevice || ![9,0,8,4,7].includes(connectedDevice.estado?.status ?? 0)) return true;
                                return false;
                            },*/
                            action(item, selectedItems) {
                                const connectedDevice = getConnectedDevice(item);
                                if (!connectedDevice) return;
                                sendGenerateExport(connectedDevice.idConexion);
                            },
                        }]}
                    >
                        <Table.Column<EquipoProcesamiento>
                            width={`25%`}
                            title="Nombre"
                            dataIndex={"Nombre"}
                            sorter
                            render={(val, record) =>
                                <EditableCell<Partial<EquipoProcesamiento>>
                                    save={api.save}
                                    id={record.Id}
                                    render={(value) => value.Nombre!}
                                    formValue={{ Nombre: val }}
                                    formItem={<Form.Item style={{ marginBottom: 0 }} name={"Nombre"} ><Input maxLength={150} /></Form.Item>}
                                    value={record} />
                            }
                            defaultSortOrder={'descend'}
                            sortDirections={["ascend", "descend", "ascend"]}
                            filterDropdown={(props) => {
                                return (
                                    <DataFilter filterDropdownProps={props} form={nombreFilterForm} >
                                        <Form.Item name={"Nombre"} style={{ marginBottom: 10 }}>
                                            <Input placeholder='Nombre...'></Input>
                                        </Form.Item>
                                    </DataFilter>
                                );
                            }
                            }
                        />

                        <Table.Column<EquipoProcesamiento>
                            width={`60%`}
                            title="Estado"
                            render={(val, record) =>
                                    <>
                                    {getStatus(record) ? 
                                    <>
                                    
                                    <span>{//@ts-ignore
                                    statusText[getStatus(record)?.status!]}</span>
                                    
                                    {[2,8].includes(getStatus(record)?.status!)
                                    &&
                                    <ProcessingInfo >
                                        <Progress 
                                        style={{width:'90%',margin:'auto'}}
                                        status={(getStatus(record)?.info.processed_count/getStatus(record)?.info.stream_count)>=1 ? 'success':'normal'}
                                        percent={parseFloat(((getStatus(record)?.info.processed_count/getStatus(record)?.info.stream_count)*100).toFixed(2))}   />

                                        <span>
                                            <span>Pendientes: </span><span>{getStatus(record)?.info.not_processed_stream_count}</span>
                                        </span>
                                        {getStatus(record)?.info.devices_to_process && (
                                            <>
                                                <span> - </span>
                                                <span>
                                                    <span>Equipos: </span>
                                                    <span>{getStatus(record)?.info.devices_to_process}</span>
                                                </span>
                                            </>
                                        )}
                                    </ProcessingInfo>
                                   }
                                   {serverMessages.length > 0 &&
                                   <ServerMessages>
                                        {serverMessages
                                            .filter((message)=>record.Nombre == message.device_name)
                                            .reverse()
                                            .map((message,index)=>
                                            <div key={index}>
                                                <span>{message.dt.format("DD-MM-YYYY HH:mm:ss")}</span>
                                                <span>{message.text}</span>
                                            </div>
                                        )}
                                    </ServerMessages>}

                                    </>
                                    : "Desconectado"}
                                    </>
                            }
                        />


                        <Table.Column<EquipoProcesamiento>
                            width={`5%`}
                            title=""
                            render={(val, record) =>
                                <>
                                    {getStatus(record) ? 
                                    <StatusLed status="on" />:<StatusLed status="off"/>}
                                </>
                            }
                        />

            </DataTable>
        </MainLayout>
    );

};